<template>
    <HeroSlider
        :tipoElemento="'NUB_SLIDER'"
    />
    <!-- Fine hero image -->
    <section class="Section">
        <Catalogslist></Catalogslist>
        <div class="Container">
            <div class="Box"><div class="Bookmark"><span>{{ this.risorse["ComeUsareB2b"]}}</span></div></div>
            <div class="Box">
                <div class="Frame">
                    <div class="HowToUseBox">
                        <div class="HowToUseItem">
                            <div class="HowToUseIcon"><img src="/images/CmsData/CatalogueIcon120.png" srcset="/images/CmsData/CatalogueIcon120Retina.png 2x" alt=""/></div>
                            <div class="HowToUseTextBox">
                                <div class="HowToUseTitle">{{ this.risorse["ComeUsareB2b"] }}</div>
                                <div class="HowToUseText">{{ this.risorse["NavigaCatalogoText"] }}</div>
                            </div>
                        </div>
                        <div class="HowToUseItem">
                            <div class="HowToUseIcon"><img src="/images/CmsData/ModelIcon120.png" srcset="/images/CmsData/ModelIcon120Retina.png 2x" alt=""/></div>
                            <div class="HowToUseTextBox">
                                <div class="HowToUseTitle">{{ this.risorse["AggiungiProdotto"] }}</div>
                                <div class="HowToUseText">{{ this.risorse["AggiungiProdottoText"] }}</div>
                            </div>
                        </div>
                        <div class="HowToUseItem">
                            <div class="HowToUseIcon"><img src="/images/CmsData/GotoShopIcon120.png" srcset="/images/CmsData/GotoShopIcon120Retina.png 2x" alt=""/></div>
                            <div class="HowToUseTextBox">
                                <div class="HowToUseTitle">{{ this.risorse["ProcediOrdine"] }}</div>
                                <div class="HowToUseText">{{ this.risorse["ProcediOrdine"] }}</div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="Section">
        <div class="Container">
            <div class="Box"><div class="Bookmark"><span>{{ this.risorse["StoricoOrdini"] }}</span></div></div>
            <div class="Box">
                <div class="Frame">
                    <HistoryTable 
                        :count="10"
                        :isInHome="true"
                    />
                    <div class="SeeMoreButton">
                        <div class="Button Stroked Small"><router-link :to="{'name': 'OrderHistory'}" >{{this.risorse["VediTuttiOrdini"]}}</router-link></div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

import HistoryTable from '@/components/Historytable.vue'
import Catalogslist from '@/views/Catalogslist.vue'
import HeroSlider from '@/components/HeroSlider.vue'
import {risorseMixin} from "@/mixin.js";

export default {
    name: 'Home',
    components: {
        HistoryTable,
        Catalogslist,
        HeroSlider
    },
    mixins:[risorseMixin],
}
</script>
